var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGvt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32901)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#16B9AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.625 7.42106C14.625 10.4631 12.1011 12.9375 9 12.9375C5.89894 12.9375 3.375 10.4625 3.375 7.42219C3.375 7.19831 3.3885 6.97387 3.41662 6.75112H4.42687C4.39312 6.97331 4.37625 7.19775 4.37625 7.42219C4.37625 9.9225 6.45075 11.9571 9.00056 11.9571C11.4339 11.9571 13.4342 10.1053 13.6131 7.76363H6.4575C6.60937 8.85713 7.47169 9.72562 8.58206 9.90506C9.693 10.0839 10.7927 9.53156 11.2944 8.54381H12.3772C11.8851 9.96244 10.5266 10.9164 8.99888 10.9176C7.03238 10.9176 5.43206 9.34875 5.43206 7.42106C5.43206 7.19606 5.45456 6.97106 5.49788 6.75H14.5834C14.6115 6.97275 14.625 7.19662 14.625 7.42106Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32901"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGvt);
export default __webpack_public_path__ + "static/media/gvt.6c812d482127baff0f3879dd56488268.svg";
export { ForwardRef as ReactComponent };